import { Routes } from '@angular/router';
import { AppRoutes } from '@mri-platform/dsg/core';
import { FeatureFlagsResolver } from '@mri-platform/dsg/entity-state';
import { HomePageComponent, ReportInfoHasAnyResolver, ShellComponent } from '@mri-platform/dsg/shell';
import { UnhandledErrorPageComponent } from '@mri-platform/shared/shell';
import { AuthGuard, ClientSelectionGuard } from '@mri/angular-wfe-proxy-oidc';

export const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard, ClientSelectionGuard],
    component: ShellComponent,
    children: [
      {
        path: 'about',
        outlet: 'modal',
        loadChildren: () => import('@mri-platform/dsg/about')
      },
      {
        path: 'onboard-config',
        loadChildren: () => import('@mri-platform/dsg/client-onboard-config')
      },
      AppRoutes.Home.applyTo({
        component: HomePageComponent,
        resolve: { featureFlags: FeatureFlagsResolver, hasDashboards: ReportInfoHasAnyResolver }
      }),
      AppRoutes.InsightEvals.applyTo({
        loadChildren: () => import('@mri-platform/dsg/insight-evals')
      }),
      AppRoutes.Error.applyTo({ component: UnhandledErrorPageComponent }),
      AppRoutes.AiUsage.applyTo({
        loadChildren: () => import('@mri-platform/dsg/ai-usage').then(module => module.aiUsageRoutes)
      }),
      {
        path: 'command-center',
        loadChildren: () => import('@mri-platform/dsg/command-center')
      },
      {
        path: 'data-sources',
        loadChildren: () => import('@mri-platform/dsg/data-sources')
      },
      {
        path: 'portfolio-explorer',
        loadChildren: () => import('@mri-platform/dsg/portfolio-explorer')
      },
      {
        path: 'create-module-view',
        loadChildren: () => import('@mri-platform/dsg/create-module-view')
      },
      {
        path: 'module-view',
        loadChildren: () => import('@mri-platform/dsg/module-view')
      },
      {
        path: 'dashboards',
        loadChildren: () => import('@mri-platform/dsg/dashboards')
      },
      {
        path: 'switch-client',
        outlet: 'drawer',
        loadChildren: () => import('@mri-platform/dsg/client-switch')
      },
      {
        path: 'user-settings',
        loadChildren: () => import('@mri-platform/dsg/user-settings')
      },
      {
        path: 'access-management',
        loadChildren: () => import('@mri-platform/dsg/access-management')
      },
      {
        path: 'reconciliation',
        loadChildren: () => import('@mri-platform/dsg/reconciliation')
      },
      { path: '', redirectTo: AppRoutes.Home.path, pathMatch: 'full' }
    ]
  },
  AppRoutes.ClientSelection.applyTo({
    canActivate: [AuthGuard],
    loadComponent: () => import('@mri/angular-wfe-proxy-oidc-client-selection').then(m => m.ClientSelectionComponent)
  })
];
